import { Component, OnInit } from '@angular/core';
import { BannerCardComponent } from 'src/app/shared/components/banner-card/banner-card.component';
import { BannerCardService } from 'src/app/shared/components/banner-card/banner-card.service';

@Component({
  selector: 'app-anywhere-care',
  templateUrl: './anywhere-care.component.html',
  styleUrls: ['../../../../../shared/components/banner-card/banner-content.component.scss']
})
export class AnywhereCareComponent extends BannerCardComponent implements OnInit {

  constructor(public bannerCardService: BannerCardService) {
    super(bannerCardService);
  }

  ngOnInit(): void {
  }
}
